"use strict";

exports.__esModule = true;
var _ElementThumbnail = require("./ElementThumbnail");
Object.keys(_ElementThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementThumbnail[key]) return;
  exports[key] = _ElementThumbnail[key];
});
var _MissingWidgetThumbnail = require("./MissingWidgetThumbnail");
Object.keys(_MissingWidgetThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MissingWidgetThumbnail[key]) return;
  exports[key] = _MissingWidgetThumbnail[key];
});